module.exports = __webpack_public_path__ + "static/media/elk_samples_bg.b97164c4.jpg";